import { useQuery } from '@tanstack/react-query'
import { getSupabase } from '@dogdisk/shared'

export type WalletRow = {
  id: string
  user_id: string
  currency: string
  balance: string
}

// safewallet 单腿模型(2026-05-18 合并):一行一钱包,方向 = amount 符号(transfer 双方 SUM=0)
export type WalletTxRow = {
  id: string
  wallet_id: string
  type: string
  amount: number
  reference_type: string
  reference_id: string
  remark: string | null
  created_at: string
}

// 流水行展示派生:方向/文案/绝对值金额(wallet.tsx 渲染用)
export function txDisplay(tx: WalletTxRow): { isOut: boolean; label: string; amountAbs: number } {
  return {
    isOut: tx.amount < 0,
    label: tx.remark || '交易',
    amountAbs: Math.abs(tx.amount),
  }
}

export function useCoinBalance(userId: string | undefined) {
  return useQuery({
    queryKey: ['wallet', 'coin', userId] as const,
    enabled: Boolean(userId),
    queryFn: async (): Promise<WalletRow | null> => {
      if (!userId) return null
      const sb = getSupabase()
      // v_wallet: security_invoker 视图,底表 wallet_select_own RLS 限自己钱包
      const { data, error } = await sb
        .schema('safewallet')
        .from('v_wallet')
        .select('id, user_id, currency, balance')
        .eq('owner_type', 'user')
        .eq('user_id', userId)
        .eq('currency', 'COIN')
        .maybeSingle()
      if (error) throw error
      return data as WalletRow | null
    },
  })
}

export function useRecentTransactions(walletId: string | undefined, limit = 20) {
  return useQuery({
    queryKey: ['wallet', 'tx', walletId, limit] as const,
    enabled: Boolean(walletId),
    queryFn: async (): Promise<WalletTxRow[]> => {
      if (!walletId) return []
      const sb = getSupabase()
      // v_wallet_transaction: security_invoker 视图,底表 wt_select_own RLS 限自己钱包
      const { data, error } = await sb
        .schema('safewallet')
        .from('v_wallet_transaction')
        .select('id, wallet_id, type, amount, reference_type, reference_id, remark, created_at')
        .eq('wallet_id', walletId)
        .order('created_at', { ascending: false })
        .limit(limit)
      if (error) throw error
      return (data ?? []) as WalletTxRow[]
    },
  })
}
